import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import '../../src/styles/App.css';

const About = () => {
  const ref = useIntersectionObserver();

  return (
    <section id="about" className="section">
      <div ref={ref} className="container container-lg" data-animate>
        <div className="card-glass">
          <h2 style={{ marginBottom: '12px' }}>Who I am</h2>
          <p
            style={{
              margin: '0',
              color: 'var(--muted)',
              fontSize: '14px',
              lineHeight: '1.6'
            }}
          >
            I am <strong>Kumail_Abbas</strong>, an AI & Software Engineer with experience in
            React, Python, FastAPI, ASP.NET, and automation systems. I specialize in
            building reliable and scalable solutions that solve real-world problems.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
